module.exports = __webpack_public_path__ + "img/power lines.ce40847a.svg";